import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { Toaster } from "sonner";
import * as Sentry from "@sentry/react";
import {
  BrowserRouter,
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes
} from "react-router-dom";

Sentry.init({
  dsn: window.VITE_SENTRY_DSN,
  integrations: [
    // If you're using react router, use the integration for your react router version instead.
    // Learn more at
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
    Sentry.replayIntegration({
      maskAllText: false
    }),
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes
    }),
    Sentry.feedbackIntegration({
      autoInject: true,
      showBranding: false,
      isEmailRequired: true,
      isNameRequired: true
    })
  ],
  tunnel: "/sentry",
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for tracing.
  // Learn more at
  // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
  tracesSampleRate: 1.0,
  // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
  tracePropagationTargets: [new RegExp("account\\..*\\.heka\\.ai*.", "")],
  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  // Learn more at
  // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
  replaysSessionSampleRate: 0.3,
  replaysOnErrorSampleRate: 1.0,
  profilesSampleRate: 1.0,
  environment: window.VITE_SENTRY_ENV,
  enabled: window.VITE_SENTRY_ENV === "local" ? false : true
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Toaster richColors={true} />
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
